// A nested structure should be used to easily find elements later
const i18n_en = {
  translation: {
    menu: {
      definition: "The idea",
      liste: "The Worldlist",
      worldmodel: 'The worldmodel',
      konzept: "Our Concept",
      about: "About Us",
      buecher: "The Books",
      reisen: "Our Travels",
      kommentare: "Feedback",
      impressum: "Legal notice",
      datenschutz: "Privacy policy",
      privacysettings: 'Privacy Settings',
    },

    // ================== Welcome page (Home page) + its sections
    welcome: {
      hero: {
        subtitle: 'Looking for extremes',
        h1: 'The whole world in 6,000 highlights',
        img: {
          src: '/Img/Welcome/01_Flussgabelung.jpg',
          alt: ''
        }
      },
      definition: {
        h2: 'The idea',
        text: 'The Frank Grosse World Highlights List captures the entire world in 6,000 world highlights <strong>– systematically and objectively.</strong>',
        buttonLink: 'definition',
        buttonText: 'To the idea',
        img: {
          src: '/Img/Welcome/02_Trockentaeler.jpg',
          alt: '',
          width: '500px',
          // height: '253px'
        }
      },
      liste: {
        h2: 'The worldlist',
        text:
          [
            'She captures the essential features of the highlights.',
            'In tabular format: Localization, Rating, Category',
            'as overview: Description, Visit Dates',
            'Google Maps and Photos'
          ],
        buttonLink: 'worldlist',
        buttonText: 'To the worldlist',
        img: {
          src: [
            '/Img/Welcome/03_Liste.webp',
            '/Img/Welcome/03_Liste.png'
          ],
          alt: '',
          width: '558px',
          height: '398px'
        }
      },
      worldmodel: {
       h2: 'The worldmodel',
        text:
          [
            'it captures the world holistically,',
            'in 1500 categories,',
            'the world extreme for each category',
            'the top ten world highlights for each category',
            'the top ten kinds for each category',
            'it relates all phenomena to their category rather than to their location.',
          ],
        buttonLink: 'worldmodel',
        buttonText: 'To the worldmodel',
        img: {
          src: '/Img/Welcome/Weltmodell.png',
          alt: '',
          width: '516px',
          // height: '398px'
        }
      },
      konzept: {
        h2: 'The concept',
        text:
          [
            'Travel joy as the ultimate goal',
            'Criteria for selection',
            'Rating and Ranking',
          ],
        buttonLink: 'concept',
        buttonText: 'To the concept',
        img: {
          src: '/Img/Welcome/04_Reisefreude.jpg',
          alt: '',
          width: '516px',
          height: '398px'
        }
      },

      about: {
        h2: 'About us',
        text:
          [
            'Traveling in partnership',
            'The shock',
            'The final chapter was devoted to extremes',
            'The close of my career',
            'Our Reviews'
          ],
        buttonLink: 'about',
        buttonText: 'About us',
        img: {
          src: '/Img/Welcome/05_Harmonie.jpg',
          alt: '',
          width: '516px',
          height: '398px'
        }
      },

      travels: {
        h2: 'Our Travels',
        text:
          [
            'Traveling the entire world',
            'World highlights are the travel destinations.',
            'Travel quality and travel efficiency at the same time',
            'Traveling with a personal sense of meaning',
            'Traveling with joy as the ultimate aim',
          ],
        buttonLink: 'travels',
        buttonText: 'Our Travels',
        img: {
          src: '/Img/Welcome/07_Reisen.jpg',
          alt: '',
          width: '516px',
          // height: '398px'
        }
      },

      books: {
        h2: 'The books',
        text:
          [
            'The books cover our expertise in 5 volumes: Success concept, Implementation, Training, Role models, Autobiography',
            'Volumes 1 and 2 cover the foundation of this website, while the other 3 complement the foundation.',
            'Volume 1: The Concept of Success, Volume 2: Its Implementation',
          ],
        buttonLink: 'book',
        buttonText: 'To the books',
        img: {
          src: '/Img/Welcome/06_Buecher_EN.jpg',   // Fallback JPG/PNG
          alt: '',
          width: '578px',
          height: '380px'
        }
      }
    },

    // ===================== Definition page + sections
    definition: {
      hero: {
        subtitle: 'Looking for something unique',
        h1: 'The idea of the World Highlights List',
        text: [
          '<strong>It captures everything essential about the world, phenomena that are superlative, unique or typical. It arises empirically from observation and experience – inductively: What is? And it organises analytically through categorisation – deductively: What could be? This is how the central benchmarks ‘6,000 highlights’ and ‘1,500 categories’ are created, and with them the yardstick for those who want to see the whole world.</strong>'
        ],
        img: {
          src: '/Img/Welcome/01_Flussgabelung.jpg',
          alt: '',
          caption: 'Alexander von Humboldt\'s destination<br /> The largest river bifurcation in the world',
        },
        EnumerateTag: 'p',
      },
      warum6000Highlights: {
        element: 'Line',
        h2: 'Why 6,000 world highlights?',
        text: [
          '<strong>Extreme:</strong><br>This number encompasses the entire world in its extremes: superlatives, uniqueness, typicality.<br/><br/>',
          '<strong>Possible:</strong><br>This number can be visited with joy and in meaningful quality in one lifetime of travel. We have proven that.'
        ],
        img: {
          src: '/Img/Definition/02 Naturgenuss.jpg',
          alt: '',
          width: '450px',
          caption: 'Humboldt\'s Joy of Nature',
        },
        img2: {
          src: '/Img/Definition/03 Erlebniswelt.jpg',
          alt: '',
          width: '450px',
          caption: 'Humboldt\'s World of Experience',
        }
      },
      minMax: {
        element: 'TwoColumn',
        text: [
          '<strong>Maximum:</strong><br>Can one see more than 6,000?<br>Possibly, but so far no one has visited more. At the moment, it is the highest value.',
          '<strong>Minimum:</strong><br>When comparing literature, it becomes clear: 2,000 highlights are the minimum for the entire world.'
        ]
      },
      traumblick: {
        element: 'WideImage',
        img: {
          src: '/Img/Definition/04_Traumblick.jpg',
          alt: '',
          caption: 'Humboldt\'s dream view, Caracas from the Avila, Humboldt Hotel',
        },
      },
      einzigartig1: {
        h2: 'Why is using the worldlist unique?',
        text: [
          '<strong>Interactive:</strong><br>The list offers globally unique selection and sorting options with a dynamic selection logic and extremely user-friendly interface without any technical jargon.<br /><br />',
          '<strong>Scope:</strong><br>This list is about five times as extensive as the UNESCO World Heritage List, as it covers the entire world, unlike the World Heritage which only includes a part of the world.'
        ],
        img: {
          src: '/Img/Definition/05 Trockentaeler.jpg',
          alt: '',
          width: '450px',
          caption: 'The Dry Valleys of Antarctica',
        },
        img2: {
          src: '/Img/Definition/06 Japanburg.jpg',
          alt: '',
          width: '450px',
          caption: 'The Matsuyama Castle in Japan',
        }
      },
      besuchsziele: {
        element: 'TwoColumn',
        text: [
          '<strong>Visitor Destinations:</strong><br>The list includes all UNESCO World Heritage sites, but often not as large protected areas, but as precisely defined and evaluated Visitor destinations. 40% of the World Heritage sites have been focused or expanded towards this goal. The list clearly shows the relationship to the World Heritage sites.',
          '<strong>Ultimate:</strong><br>The entire world is captured in a single list: castles, volcanoes, bars, documents, museums, beaches, festivals, ethnicities, rivers, pleasures, discos. The ultimate world list that can be joyfully experienced in a lifetime of travel.'
        ]
      },
      markt_abbey: {
        align: false,
        img: {
          src: '/Img/Definition/07 Anfahrt zum Markt.jpg',
          alt: '',
          width: '550px',
          caption: 'Heading to the market in Ganvie, Benin',
        },
        img2: {
          src: '/Img/Definition/08 Schottisches Kloster.jpg',
          alt: '',
          width: '450px',
          caption: 'Iona Abbey in Scotland, Hebrides',
        }
      },
      einzigartig2: {
        h2: 'Why is the content of the worldlist unique?',
        text: [
          '<strong>Quality:</strong><br>The list is based on two books that comprehensively explain the concept, philosophy, and implementation process. <br /><br />',
          '<strong>Classification:</strong><br>The list is as objective as possible, with objectivity based on a consistent classification system.<br /><br />',
          '<strong>Benchmark:</strong><br>This list sets the standard for travel quality, as it features only the very best, typically 5 to 10 highlights per category, with a range between 3 to 20 highlights. <br /><br />',
        ],
        img: {
          src: '/Img/Definition/09 Teo im Eistunnel.jpg',
          alt: '',
          width: '450px',
          caption: 'Teo in the ice tunnel of East Antarctica',
        },
        img2: {
          src: '/Img/Definition/10 Autor mit Anaconda.jpg',
          alt: '',
          width: '450px',
          caption: 'The author with an Anaconda, Venezuela',
        }
      },
      kategorien: {
        element: 'SingleColumn',
        align: false,
        text: [
          '<strong>Categories:</strong><br>The highlights are assigned to 1,500 categories, capturing their essence in a broad sense. Within the category, they can be compared to each other, resulting in a ranking. <br /><br />',
          '<strong>Essential:</strong><br>The "description" explains the essence of the highlight with clear criteria. With the most significant criteria, it is possible to create numerical rankings, first according to mega, top, and standard highlights, and then with specific criteria in more detail.<br /><br />',
        ],
      },
      ganzeinheitlich: {
        element: 'SingleColumn',
        width: 60,
        align: false,
        h2: 'Why is the worldlist holistic?',
        text: [
          'Because it embraces <strong>the entire world</strong> and the <strong> entire travel life.<br/><br />',
          ' She defines highlights in a way that achieves <strong> these two goals</strong>, without getting sidetracked. That sets her apart from all other lists.<br/><br />',
          'She defines highlights in a way that makes <strong> travel a matter of true experience <strong> – not just seeing places, taking photos, sharing, and ticking them off. <br/><br />',
          'This is achieved through holistic categorization - <strong> taxonomy<strong> - and <strong> comprehensive localization<strong>: The <strong> starting location <strong> – the practical point of departue for the visit; <strong> sub-locations <strong> – essential places within the site that together define its core experience; and <strong> optional locations<strong>  – nearby additions that complement the visit when time and logistics allow.',
        ],
      },
      reisen: {
        element: 'Box',
        EnumerateTag: 'li',
        h2: 'Traveling means,',
        text: [
          'to understand the essence of the place',
          'to guide the visit with aesthetic and ethical values',
          'to experience the place with all modes of perception',
          'To realize seeing, feeling, hearing, imagining simultaneously during the visit.',
        ]
      },
      evangelisten: {
        element: 'ImageArray',
        align: false,
        images: [
          {
            src: '/Img/Definition/11a Matthaeus.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11b Markus.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11c Lukas.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11d Johannes.jpg',
            alt: '',
            width: '250px',
          },
        ]
      },
      evangelisten_text: {
        element: 'SingleColumn',
        width: 80,
        class: 'smalltext',
        text: [
          'The four evangelists Matthew, Mark, Luke, and John by Tilman Riemenschneider in the Bode Museum in Berlin each perceive differently: Matthew sees, Mark feels, Luke hears, John teaches, but they process the different sensory impressions into a common holistic perception<br />of the state of enlightenment, the knowledge of the whole, the highest value<br />they experience God<br />and they experience joy, subtle, but deep -<br />the best wood carving of all time.<br />And that\'s what traveling is about, joy, even though worldly joy may come across as much more exuberant, It still arises from inner wholeness as opposed to fun which is triggered by a superficial stimulus.'
        ]
      },
      humboldt: {
        element: 'Box',
        h2: 'This holistic approach to traveling was invented by Alexander von Humboldt.',
        EnumerateTag: 'li',
        text: [
          '"All is interaction"',
          '"Nature as a living organism" and not a mechanical structure, back then the "world clock".',
          'So he invented the web of life, globalization, ecology, the mobile of thought.',
          'Back then a revolution, today a matter of course for us.'
        ],
        footer: 'The greatest genius of all time. In his honor, we have started with four pictures from his perspective on the world:<br />River fork, Joy of Nature, World of experience, Dream view.',
      },
      worumesnichtgeht: {
        element: 'Accordion',
        width: 60,
        align: true,
        h2: 'What it\'s not about',
        elements: [
          {
            header: 'It\'s not about formalities, but about content.',
            text: 'Highlights capture contents, such as locations, places, sites, not formalisms like regions, boundaries, shores. They show what one should experience, not just cross borders or set foot on island shores.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/1a.gif',
                alt: '',
                width: '200px',
                height: '159px',
                subtitle: 'Not lines',
              },
              {
                src: '/Img/Definition/Akkordeon/1b.jpg',
                alt: '',
                width: '200px',
                height: '150px',
                subtitle: 'but contents',
              },
            ]
          },
          {
            header: 'It\'s not about many lists, but about a single one.',
            text: 'There are organizations that offer many lists of travel destinations to cater to individual interests. In contrast, we want to integrate all objectively important information into a single list. We value objectivity over subjectivity. UNESCO offers three lists because the contents of travel destinations vary, such as material and immaterial aspects. However, everything must manifest in one place for it to be a travel destination. Everything can be integrated into one list. Only a single list maintains the overview.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/2a.png',
                alt: '',
                width: '150px',
                height: '145px',
                subtitle: 'Not several',
              },
              {
                src: '/Img/Definition/Akkordeon/2b.png',
                alt: '',
                width: '150px',
                height: '281px',
                subtitle: 'but a single',
              },
            ]
          },
          {
            header: 'It\'s not about long lists, but about achievable goals.',
            text: 'There are organizations that offer over 60,000 travel destinations. One could choose individually. Correct, but what value do they have as travel destinations? Since one can only visit about 6,000, that would be only 10% of 60,000. For the goal of seeing the whole world, this offer is counterproductive. The longer, the worse.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/3a.svg',
                alt: '',
                width: '150px',
                height: '150px',
                subtitle: 'Not long.',
              },
              {
                src: '/Img/Definition/Akkordeon/3b.svg',
                alt: '',
                width: '120px',
                height: '120px',
                subtitle: 'but feasible',
              },
            ]
          },
          {
            header: 'It\'s not just about popular destinations, but above all about essential destinations.',
            text: 'We do take visitor numbers into account and thus respect the judgment of the many - but not per se, not as a value in itself. Other criteria must be added. If a city doesn\'t have much to offer, but has an amusement park, that place will have a high position in Google\'s highlight list, but it will not appear in ours. To recognize the essential, one needs systematic and comprehensive overview, a methodology, and not constantly changing evaluators with different perspectives.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/4a.jpg',
                alt: '',
                width: '150px',
                height: '139px',
                subtitle: 'Not many likes',
              },
              {
                src: '/Img/Definition/Akkordeon/4b.jpg',
                alt: '',
                width: '150px',
                height: '112px',
                subtitle: 'but essential',
              },
            ]
          },
        ]
      },
      liste: {
        align: false,
        buttonLink: 'worldlist',
        buttonText: 'To the list',
        color: 'fire',
        img: {
          src: [
            '/Img/Welcome/03_Liste.webp',
            '/Img/Welcome/03_Liste.png'
          ],
          alt: '',
          width: '558px',
          height: '398px'
        }
      },
    },

    // ==================== LISTE
    list: {
      hero: {
        subtitle: 'The table on the internet',
        // h1: 'Frank Grosse World Highlight List',
        img: {},
      },
      erlaeuterung: {
        element: 'TwoColumn',
        text: [
          '<strong>The term list</strong>: It is used here in a comprehensive sense.<br><br>' +
          'The list of world highlights includes three forms:<br><br>' +
          '<ul><li><strong>Tabular format</strong>: The central form of the list. Its goal is to define the highlights. More than 90,000 pages when translated and extrapolated to physical dimensions<br><br><li><strong>Name list</strong>: A clear form for assigning to the region and the world heritage. It is suitable for a personal recording of what has been seen. About 100 pages. <br><br><li><strong>Summary list</strong>: It records the number of highlights per continent and per country, divided into groups, alongside the number of world heritages in the UN definition and in the Visitor Destinations. About 8 pages.</ul>',
          '<strong>Regarding the tabular format</strong>: It is the core product of our travel work: 5 books and the website. For the user who wants to access the list repeatedly, the website is designed in a way that they can get to the list with just two clicks. For the user who wants to learn about the foundation of the list, the graphic is hierarchically structured: From the main point to the subpoint.<br /><br />' +
          '<strong>Purpose of the list</strong>: Interactive selection of the highlight and analysis of its essence through description, localization, and categorization.<br /><br />' +
          '<strong>Analysis of the Essence</strong> through categorization in up to 4 dimensions with 1,500 categories.<br /><br />' +
          '<strong>Category input</strong> compares the highlight with all others in the same category.<br /><br />' +
          '<strong>Determination of ranking</strong> of highlights per category (still in the early stages).'
        ],
      },
      erlaeuterung2: {
        h2: 'Explanation',
        align: false,
        // text: [
        //   '<strong>Der Begriff Liste</strong>: Er wird hier im umfassenden Sinn gebraucht.<br><br>',
        //   'Die Liste der Welthighlights umfasst drei Formen:<br><br>',
        //   '<ul><li><strong>Tabellenform</strong>: Die zentrale Form der Liste. Ihr Ziel ist die Definition des Highlights.<br><br><li><strong>Namensliste</strong>: Eine übersichtliche Form zur Zuordnung zur Region und dem Welterbe. Sie eignet sich für eine persönliche Erfassung des Gesehenen.<br><br><li><strong>Summenliste</strong>: Sie erfasst die Anzahl der Highlights je Kontinent und je Land, unterteilt nach Gruppen, daneben die Anzahl der Welterben in der UN-Definition und in der Definition der Besuchsziele.</ul>',
        // ],
        img: {
          src: '/Img/Liste/01 Ewe-Dorf in Togo.jpg',
          alt: '',
          width: '450px',
          caption: 'Ewe village in Togo',
        },
        img2: {
          src: '/Img/Liste/02 Bamberger Rathaus.jpg',
          alt: '',
          width: '450px',
          caption: 'Bamberg Town Hall',
        }
      },
      spacer: {
        element: 'SingleColumn',
      },
      benutzung: {
        element: 'SingleColumn',
        h2: 'Usage',
        width: 60,
        align: true,
        text: [
          'The above table is comprehensive yet extremely user-friendly without any technical jargon. It is interactive, with its selection taking into account logical connections to other criteria. If you choose Germany, then "Continent" will show Europe, because Germany only has land ownership in Europe. If you choose the United Kingdom, then all continents where the United Kingdom has land ownership will appear under "Continent".<br><br>',
          '<strong>Screen optimization</strong> for the table format:<br> Following the requirements of a matrix-like table format, we optimize for computer screens. Those who only read the list with a mobile display will not fully benefit, as that is inherent to a table.<br><br>',
          '<strong>Evaluation of highlights</strong>: The characteristics of a highlight are not only evaluated in isolation, but always from the traveller\'s point of view: the overall experience, the connection to the country and the environment, the enrichment of the traveller. Take restaurants, for example: Michelin evaluates the dish, but we take that judgement and relate it to the overall experience. <br><br>',
          '<strong>Definition of highlights</strong>: Here, too, the traveller\'s perspective plays a decisive role: where is it located, how do I get there, how significant is it? The table contains a clear location and the starting point for the visit.  Especially for lesser-known places, the name should hint at their essence.<br />Example: 500 UNESCO World Heritage Sites are protected areas. We redefine them as geographically clear destinations where the essence of world heritage can be discovered.'
        ],
      },
      disclaimer: {
        element: 'TwoColumn',
        text: [
          '<strong>Disclaimer:</strong><br> Highlights have mostly been selected for each category, but the ranking process is still in its early stages.',
          '<strong>Tour:</strong><br>We have compiled all explanations in a "Tour". Click on Tour and see for yourself how simple, clear, and informative the table is.'
        ],
        button2Text: 'Tour',
      },
      spacer4: {
        element: 'SingleColumn',
      },
      spacer5: {
        element: 'SingleColumn',
      },
      ergaenzungen: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        h2: 'Additions to the list',
        textbutton: [
          {
            text: 'Highlights: Name List',
            buttonText: 'LINK',
            buttonLink: 'name_list'
          },
          {
            text: 'Highlights: Summary List',
            buttonText: 'LINK',
            buttonLink: 'sum_list'
          },
          {
            text: 'Category List',
            buttonText: 'LINK',
            buttonLink: 'category_list'
          },
          {
            text: 'World Heritage List and Visitor Destinations',
            buttonText: 'planned',
            buttonLink: ''
          },
        ],
        // img: {
        //   src: [
        //     '/Img/Welcome/03_Liste.webp', // Preferred WebP (for Mockups)
        //     '/Img/Welcome/03_Liste.png'   // Fallback JPG/PNG
        //   ],
        //   alt: '',
        //   width: '558px',
        //   height: '398px'
        // }
      },
    },

    // ================== ABOUT
    about: {
      hero: {
        subtitle: 'About us',
        h1: 'The partners',
        img: {
          src: '/Img/About/Panorama.jpg',
          alt: '',
          caption: 'Lesotho, Maletsunyane Falls',
        },
      },
      widmung: {
        element: 'Box',
        EnumerateTag: 'p',
        h2: 'Dedication',
        color: 'gray',
        textAlign: 'justify',
        sectionBackgroundCss: 'sectionBackgroundTextBlack',
        text: [
          '',
          'I dedicate my books <i>Reiselust</i> and my website <i>World List</i> to my life partner',
          '<strong>Teodoro L. Murallon, MD</strong>',
          'who passed away in 2021, my travel companion from 2006 to 2019, with whom I experienced the highest form of travel joy.',
          'It is true: shared joy is doubled joy. Before he became German, he was Filipino – a people known for adaptability and joy in life. Teo embodied this spirit perfectly. Yet he also set his own accents: on our twelve-day journey to the South Pole, he surpassed everyone.',
          'There we witnessed a miracle: we became one.',
          '<strong>The happiness of having had such a travel partner is immeasurable and eternal.</strong>',
        ]
      },
      partner: {
        element: 'TwoColumn',
        // h2: 'Die Partner',
        // width: 80,
        text: [
          '<strong>Dr. Frank W. Grosse-Oetringhaus</strong>: Business consultant and top management trainer at Siemens, wrote the leadership system for Siemens, developed a teaching on strategy, taught for 18 years at the University of St. Gallen, has been traveling since the age of 16, a total of 26 years "on the road".<br /><br />' +
          '<strong>Teo Murallon</strong>: Specialist in Anesthesiology, practiced in the Philippines, nurse in New York and Berlin, cared for Frank\'s mother until her death, which led to their partnership, traveled since the age of 35, spent a total of 13 years "on the road", died from Covid-19 at Charité - the best hospital - on 12.3.2021.<br /><br />' +
          '<strong>Our strengths:</strong><br />Frank: Creativity, organization, determination<br />Teo: Empathy, emotional intelligence, adaptability<br /><br />' +
          '<strong>Our Complementarity:<br /></strong>We were very different, but our strengths complemented each other perfectly, the reason for our success.'
        ],
        img: {
          src: '/Img/About/1a Yin Yang Filled.png',
          alt: '',
          width: '500px',
          style: { backgroundColor: 'transparent', marginTop: '100px' }
          // height: '253px'
        },
      },
      // partner: {
      //   element: 'SingleColumn',
      //   h2: 'Die Partner',
      //   width: 80,
      //   text: [
      //     '<strong>Dr. Frank W. Grosse-Oetringhaus</strong>: Unternehmensberater und Top-Managementausbilder bei Siemens, schrieb das Führungssystem für Siemens, entwickelte eine Lehre zur Strategie, 18 Jahre Dozent an der Uni St. Gallen, reist seit dem 16. Lebensjahr, insgesamt 26 Jahre „on the road“.<br /><br />',
      //     '<strong>Teo Murallon</strong>: Facharzt für Anästhesie, praktizierte in den Philippinen, Krankenpfleger in New York und Berlin, pflegte die Mutter von Frank bis zu ihrem Tod, so entstand die Partnerschaft, reiste seit dem 35. Lebensjahr, insgesamt 13 Jahre „on the road“, starb an Corona in der Charité – dem besten Krankenhaus - am 12.3.2021.<br /><br />',
      //     '<strong>Unsere Stärken:</strong><br />Frank: Kreativität, Organisation, Zielstrebigkeit<br />Teo: Empathie, emotionale Intelligenz, Anpassungsfähigkeit<br /><br />',
      //     '<strong>Unsere Komplementarität:<br /></strong>Wir waren sehr verschieden, aber unsere Stärken ergänzten sich ideal, der Grund für unseren Erfolg',
      //   ],
      // },
      partner2: {
        align: false,
        // img: {
        //   src: '/Img/About/1a Yin Yang Filled.png',
        //   alt: '',
        //   width: '500px',
        //   style: { backgroundColor: 'transparent' }
        //   // height: '253px'
        // },
        img2: {
          src: '/Img/Welcome/05_Harmonie.jpg',
          alt: '',
          width: '500px',
          caption: 'Harmony, Phuket',
        },
      },
      spacer: {
        element: 'SingleColumn',
      },
      partnerschaft: {
        h2: 'Traveling in partnership',
        text: [
          '<strong>The philosophy</strong>: We had the same philosophy of travel, so our trips together were full of harmony.<br /><br />',
          '<strong>The Meaning</strong>: We experienced all 7 categories of meaning: Wonder, Essential, Cultivation, Joy, Intensity of life, Limits of performance, Spirituality, Self-responsibility and Self-experience.<br /><br />',
          '<strong>The goal</strong>: The entire world<br /><br />',
          '<strong>The style</strong>: Intensive and systematic<br /><br />',
          '<strong>Success</strong>: <br />13 years of traveling together<br />8 years non-stop<br />4,016 shared highlights experienced together<br /><br />',
        ],
        img: {
          src: '/Img/About/3 Mt. Everest.jpg',
          alt: '',
          width: '450px',
          caption: 'Common Passion for Extremes',
        }
      },
      spacer2: {
        element: 'SingleColumn',
      },
      schock: {
        h2: 'The shock',
        align: false,
        text: [
          '<strong>The reason:</strong> From 2019 to 2021, we had to pause our travels due to heart problems and the pandemic. During this time, I wrote a comprehensive book about extreme traveling. We contracted Covid-19 in Berlin in November 2020. I had sufficient immunity, Teo did not. He was intubated in December, and we fought for his life for 2.5 months. He passed away on March 12, 2021.<br /><br />',
          '<strong>A new focus</strong>: How could I live without him? We had become one in 38 years. It took me six months to understand, not to focus on the negative, but on the positive - not that he is no longer here, but that we had a rare abundance of happiness together.<br /><br />',
          '<strong>A new foundation</strong>: In half a year, I have learned to internalize this thought and to feel happiness again. Borrowed happiness from the past as a foundation for new happiness in the future. <br /><br />',
          '<strong>A new thought</strong>: And during this time, I did even more: I did everything imaginable and possible to ensure that Teo and I never separate. This awareness of inseparability is a powerful thought for future happiness.<br /><br />',
        ],
        img: {
          src: '/Img/About/4 Teo_.jpg',
          alt: '',
          width: '400px',
          caption: 'Teo\'s 70th birthday in front of our house in Phuket',
        },
      },
      spacer3: {
        element: 'SingleColumn',
      },
      extremen: {
        h2: 'The last chapter is devoted to extremes.',
        EnumerateTag: 'li',
        text: [
          [
            'The "Bucket List" is being realized',
            'Experience of the two role models: Alexander the Great and Alexander von Humboldt. 4 Memorial Journeys',
            'I visited two difficult countries completely: Iraq and Saudi Arabia',
            'The leading luxury resorts: The Brando, Kaibu Fiji Private Islands, Laucala Island, Likuliku Lagoon, Wakaya Club & Spa, Le Bora Bora, Le Taha\'a, Vahine Private Island',
          ],
          [
            'Almost all gaps have been filled',
            '734 new highlights in 43 countries (2021-2025)',
            'Seen: All highlight groups and world heritage sites over 90% (2025: 90-95%)',
          ],
        ],
        img2: {
          src: '/Img/About/5 Reisefreude.jpg',
          alt: '',
          width: '450px',
          caption: 'We made it!',
        },
        img: {
          src: '/Img/About/6a Leistungsgrenze.jpg',
          alt: '',
          width: '450px',
          caption: 'Yanomami pull me over a <br>tree trunk with a height of 1.2 m',
        },
      },
      extremen_text: {
        element: 'SingleColumn',
        width: 70,
        align: false,
        EnumerateTag: 'li',
        text: [
          [
            'Even without a partner, I was happy',
            'Experience the Umrah pilgrimage',
            'Enchanting the Yanomami',
            'Measuring the Casiquiare',
            'Flying over 38 Tepuis in 6 days, landing on 14 and overnighting on 2'
          ],
          [
            'The key points of the travel concept have been reviewed',
            '<strong>Travel joy</strong> even under difficult conditions',
            '<strong>Realizing the extreme</strong>: 6000 in 12 years means 1.4 highlights per day',
            '<strong>Testing the extreme</strong>: 5.5 highlights per day in Europe and with joy',
            '<strong>Limits of Performance </strong>: Yanomami pull me over a 1.2m high tree trunk',
            '<strong>Developing ethical travel</strong>: Papua New Guinea, Socotra, Afghanistan',
          ]
        ],
      },
      karriere: {
        h2: 'The end of my career',
        align: false,
        text: [
          '<strong>Final goals</strong>: Completion of the world list, publication of the books, studying role models, enjoying life.<br /><br />',
          '<strong>My Final Conclusion</strong>: I have detached myself from all forms of competition. While traveling, I did not seek better quality, but quality itself. I have achieved all my goals - although Teo is missing. I was very happy with him. I have found happiness again — but never with the same depth I once shared with Teo. I have loved, helped, and seen the entire world. <br /><br />',
        ],
        img: {
          src: '/Img/About/7 Frank.jpg',
          alt: '',
          width: '350px',
          // caption: '',
        },
        // img2: {
        //   src: '/Img/About/7 Frank.jpg',
        //   alt: '',
        //   width: '350px',
        //   // caption: '',
        // },
      },
      karriere_texts: {
        element: 'SingleColumn',
        width: 70,
        text: [
          '<strong>The life model</strong>: The three life goals of loving, helping, and traveling were indeed the most important. First focusing on loving and helping, and then traveling as a main focus, was correct. <br /><br />',
          '<strong>The luxury</strong>: I started with hitchhiking, I have ended my career in extreme luxury. I wanted the full range, but more than that:  I searched for meaningful luxury and found it: <i>„Productive luxury“</i> — it improves its surroundings and gives more than it takes. That means: If the luxury resort were to disappear, the environment would be better than before. This applies to the best luxury resorts in the world: The Brando, Kaibu, Laucala. They stand for <i>Nature Joy</i>. Alexander von Humboldt invented the term <i>Nature Joy</i> and thereby pointed out the path of traveling. I have walked this path to its end. At these places one experiences it in absolute completion. <br /><br />',
          '<strong>Spirituality</strong>: It has become very important as I have gotten older. I have embraced multireligiosity, adopting four religions: Buddhism, Christianity, Islam, and Animism (rivers), but I do not belong to any religious community. This attitude is the basis of my tolerance, the key to successful traveling.<br /><br />',
        ],
      },
      bewertung: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        h2: 'Our review',
        textbutton: [
          {
            text: 'My seen highlights: Summary list',
            buttonText: 'PDF',
            buttonLink: '/pdf/561 Summenliste Gesehen.pdf'
          },
          {
            text: 'My and Teo\'s reviews',
            buttonText: 'PDF',
            buttonLink: '/pdf/562 Meine und Teos Bewertung.pdf'
          },
          {
            text: 'The goals of our travel partnership',
            buttonText: 'PDF',
            buttonLink: '/pdf/563 Ziele der Reisepartnerschaft.pdf'
          },
          {
            text: 'How travelers rate us',
            buttonText: 'PDF',
            buttonLink: '/pdf/564 Wie andere uns bewerten.pdf'
          },
        ],
        img: {
          src: '/Img/About/8.jpg',
          alt: '',
          width: '558px',
          // height: '398px',
          caption: 'Mainamati, Ragban Vihar, Bangladesh',
        }
      },
      vermaechtnisse: {
        element: 'BoxImage',
        align: false,
        EnumerateTag: 'li',
        h2: 'Legacies',
        textbutton: [
          {
            text: 'Teo\'s legacy',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/4 - Teos Legacy.pdf'
          },
          {
            text: 'Our shared legacy',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/3 - Our shared legacy.pdf'
          },
          {
            text: 'My legacy',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/2 - My Legacy.pdf'
          },
        ],
      },
    },

    // =========== KONZEPT
    concept: {
      hero: {
        subtitle: 'Reaching extremes',
        h1: 'The concept',
        text: [
          'The World List is based on a systematic <strong>concept</strong>, from which we present some thoughts here, excerpts that are intended to spark curiosity about the <strong>books</strong>. The <strong>first two volumes</strong> explain the concept (Vol. 1) and its implementation (Vol. 2) in full. <br /><br />',
          'The website is currently in the <strong>testing phase</strong>, where we are sorting out the responses. During this time, the <strong>books</strong> will also be available. Initially, sections of the "Concept", "Our Journeys", and "Our Review" elements will be presented as <strong>pdf</strong> files. Depending on the feedback, we will make adjustments. During the testing phase, the website and the books will also be available in <strong>English</strong>.'
        ],
        EnumerateTag: 'p',
        img: {
          src: '/Img/Konzept/Panorama.jpg',
          alt: '',
          caption: 'Take off to the flight to Tepui Aprada, Venezuela',
        },
      },
      kopf: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        textbutton: [
          {
            text: 'Our main goal: Peak performance',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/1 The Peak Performance.pdf'
          },
          {
            text: 'Our main goal: Travel Joy',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/2 Travel Joy.pdf'
          },
          {
            text: 'Our logo: The core ideas',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/3 Our logo.pdf'
          },
          {
            text: 'Definition of World Highlights',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/4 Definition of World Highlights.pdf'
          },
          {
            text: 'Categorization of the World (Taxonomy)',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/5 Categorization.pdf'
          },
          {
            text: 'Ranking of highlights per category',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/6 Ranking.pdf'
          },
        ],
        img: {
          src: '/Img/Konzept/Kopf.jpg',
          alt: '',
          width: '300px',
          height: '431px',
          caption: 'The Louvre',
        }
      },
      karriere_texts: {
        element: 'SingleColumn',
        h2: 'Our unique selling points',
        width: 80,
        align: false,
        text: [
          '<strong>The most comprehensive travel compendium ever created</strong>: >90,000 pages',
          '<strong>A travel compendium of peak performances</strong>: 6,000 Highlights in 12 Years',
          '<strong>The only work about travel joy as the ultimate goal of traveling</strong>',
          '<strong>A work with a proof</strong>: 90% seen out of 6,403 highlights (as of 2025)',
          '<strong>A travel work cast from a single mold</strong>: Systematic and consistent',
          '<strong>A balancing act of efficiency and quality</strong>: 1.4 highlights per day with joy',
          '<strong>A global taxonomy of travel: 1,500 categories cover the entire world</strong>',
          '<strong>The ultimate list</strong>: Comprehensive, interactive, objective, and the only one',
          '<strong>The benchmark for user-friendliness – intuitive and freely accessible</strong>',
        ],
      },
    },

    // ================= REISEN
    travels: {
      hero: {
        subtitle: 'Joy of Extremes',
        h1: 'Our Travels',
        img: {
          src: '/Img/Reisen/Panorama.jpg',
          alt: '',
          caption: 'Rijal Almaa, Saudi Arabia',
        },
      },
      overview: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        text: [
          'Travelling to extreme places',
          'Traveling on extreme routes',
          'Traveling for extreme topics',
          'Travel results: Lists of top places',
          'Ethical Travel',
          'Travel also to test our concept',
          'Memorial Journeys Alexander the Great',
          'Memorial Journeys Alexander von Humboldt',
        ],
        img: {
          src: '/Img/Reisen/00.jpg',
          alt: '',
          width: '300px',
          height: '458px',
          caption: 'Bamiyan',
        }
      },
      travel1: {
        h2: 'Traveling to Extreme Places',
        align: false,
        text:
          [
            'South Pole',
            'North Pole',
            'Russian Arctic',
            'Russian Far East',
            'The Horn of Africa',
            'Bouvet Island',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/41 Traveling to extreme sites.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/1.jpg',
          alt: '',
          width: '558px',
          height: '314px',
          caption: 'Cape Horn',
        }
      },
      travel2: {
        h2: 'Traveling on Extreme Routes',
        text:
          [
            'Aksai Chin Route, China',
            'Dogon, Mali',
            'Heart of the Sahara',
            'Antarctic semi-circumnavigation',
            'Arctic Circumnavigation',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/42 Traveling extreme routes 9 slides.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/2.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'On the road in Russian Far East',
        }
      },
      travel3: {
        h2: 'Traveling for extreme topics',
        align: false,
        text:
          [
            'Sakura in Japan',
            'Development of Humanity',
            'Gold extraction',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/43 Traveling for extreme themes 4 slides.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/3.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Sakura in Kyoto',
        }
      },
      travel4: {
        h2: 'Travel Results: Top Places Lists',
        text:
          [
            'Ethnicities',
            'Religious Sites',
            'Festivals',
            'Authentic Food',
            'Animal encounters',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/44 Travel Results Lists of the Top Places 6 slides.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/4.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Bonobos in Kinshasa, DRC',
        }
      },
      travel5: {
        h2: 'Ethical Travel',
        align: false,
        text:
          [
            'Demonstrate',
            'Support HDI',
            'Support UNESCO',
            'Help',
            'Remember',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/45 Ethisches Reisen.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/5.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Dragon\'s Blood Harvest, Socotra',
        }
      },
      travel6: {
        h2: 'Traveling also to test our concept',
        text:
          [
            'Travel Joy in Challenging Countries',
            'Testing the number of highlights',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/en/46 Test Journeys.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/6.jpg',
          alt: '',
          width: '350px',
          // height: '313px',
          caption: 'The Whirling Dervishes, Konya, Turkey',
        }
      },
      travel7: {
        h2: 'Memorial Journeys: Alexander the Great',
        align: false,
        text:
          [
            'Greece',
            'Turkey',
            'Afghanistan',
            'Pakistan',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/47 Memorial Travels for Alexander the Great 5 slides.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/7.jpg',
          alt: '',
          width: '300px',
          // height: '313px',
        }
      },
      travel8: {
        h2: 'Memorial Journeys: Alexander von Humboldt',
        text:
          [
            'History of the journey',
            'Venezuela Casiquiare, Survey',
            'Venezuela Yanomami',
            'Venezuela Orinoco River System',
            'Venezuela Llanos',
            'Venezuela Las Aves',
            'The table mountains of Venezuela',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/en/48 Memorial Travel Alexander von Humboldt.pdf',
        externalLink: true,
        buttonText: 'Travel Report',
        img: {
          src: '/Img/Reisen/8.jpg',
          alt: '',
          width: '300px',
          // height: '313px',
        }
      },
    },

    // ================ BOOK
    book: {
      hero: {
        //subtitle: 'x',
        h1: 'The books',
        // text: [
        //   'Im folgenden erhalten sie eine detaillierte Erklärung unseres Reisekonzepts'
        // ],
        // EnumerateTag: 'p',
        img: {},
      },
      kopf: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        textbutton: [
          {
            text: 'The brand represents a travel compendium',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/61 Travel Compendium.pdf'
          },
          {
            text: 'Overview of the 5 volumes',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/62 The five volumes.pdf'
          },
          {
            text: 'Book cover volume 1',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/63 Buchdeckel Band 1.pdf'
          },
          {
            text: 'Table of Contents Volume 1',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/64 Inhaltsverzeichnis Band 1.pdf'
          },
          {
            text: 'Excerpt: Volume 1, p. 7-11',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/65 Leseprobe Die drei grundlegenden Gedanken.pdf'
          },
          {
            text: 'Book cover Volume 2',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/66 Buchdeckel Band 2.pdf'
          },
          {
            text: 'Table of Contents Volume 2',
            buttonText: 'PDF',
            buttonLink: '/pdf/en/67 Inhaltsverzeichnis Band 2.pdf'
          },
        ],
        img: {
          src: '/Img/Book/1.jpg',
          alt: '',
          width: '558px',
          // height: '398px',
          caption: 'Library, St. Gallen',
        }
      },
      spacer: {
        element: 'SingleColumn',
      },
      bestellung: {
        element: 'BoxImage',
        width: 90,
        align: false,
        h2: 'Travel Joy: Volume 1',
        img: {
          src: '/Img/Book/Reiselust1_en.jpg',
          alt: '',
          width: '300px',
          height: '435px',
        },
        text: [
          'It unfolds the success concept of travelling. It explores the fundamental question of the <i>why</i> and <i>what for</i> of travelling. The focus is on the meaning of travelling - not as an abstract idea, but as a guiding force. The volume defines the success criteria of travelling and thus lays the theoretical foundation for everything that follows.',
          '<p style="margin-bottom: 0.5em;"></p>',
          'Volume 1 and Volume 2 form an intellectual unit. They do not stand side by side, but are intertwined - as a theoretical outline and practical development of a comprehensive travel concept. This concept is also the foundation of the Frank Grosse World List website',
        ],
        textbutton: [
          {
            text: 'Order the book here:',
            buttonText: 'Books on Demand',
            buttonLink: 'https://buchshop.bod.de/travel-joy-volume-1-frank-grosse-9783695729845'
          },
          {
            text: '',
            buttonText: 'Amazon',
            buttonLink: 'https://www.amazon.de/Travel-Joy-Concept-Global-Excellence/dp/3695729848'
          },
        ],
      },
      bestellung2: {
        element: 'BoxImage',
        width: 90,
        align: true,
        h2: 'Travel joy: Volume 2',
        img: {
          src: '/Img/Book/Reiselust2_en.jpg',
          alt: '',
          width: '300px',
          height: '423px',
        },
        text: [
          'It sets this foundation in motion. It answers the questions of <i>where</i> and <i>how</i> - with systematic destination overviews, concrete signposts and an intensive examination of borderline experiences and travelling style. The entire travel practice - from planning to implementation to reflection - is methodically analysed and illustrated with proven examples.',
          '<p style="margin-bottom: 0.5em;"></p>',
          'Volume 1 and Volume 2 form a conceptual unit. They do not stand side by side, but are intertwined - as a theoretical outline and practical development of a comprehensive travel concept. This concept is also the foundation of the Frank Grosse World List website',
        ],
        textbutton: [
          {
            text: 'Order the book here:',
            buttonText: 'Books on Demand',
            buttonLink: 'https://buchshop.bod.de/travel-joy-volume-2-frank-grosse-9783695734375'
          },
          {
            text: '',
            buttonText: 'Amazon',
            buttonLink: 'https://www.amazon.de/Travel-Joy-Implementing-Concept-Excellence/dp/369573437X'
          },
        ],
      },
      vorbestellung: {
        element: 'SingleColumn',
        width: 90,
        align: false,
        h2: 'Pre-order',
        text: [
          'Please sign up using the following form for the the subsequent volumes:',
          '<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc_Lkf8_CJ-oawhl7one60q_rQMo9-ozBLi7XCXDELaoiACbA/viewform?embedded=true" width="640" height="1000" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>'
        ],
      },
    },
    // =========== WELTMODELL
    model: {
      hero: {
        subtitle: 'Grasping the Whole',
        h1: 'The entire world in 1,500 categories',
        EnumerateTag: 'p',
        img: {
          src: '/Img/Modell/Wide.png',
          alt: '',
        },
      },
      schoen1: {
        element: 'Line2',
        align: true,
        text: 'The most beautiful thing we know is not a part of the world, but the world itself',
        text2: 'When it comes to beauty, the whole triumphs',
        subtitle: 'The Most Beautiful Planet in the Cosmos',
        img: {
          src: '/Img/Modell/1_Earth rise.jpg',
          alt: '',
          width: '400px',
          caption: 'Apollo 8',
          captionStyle: 'imageCaptionSmall',
        }
      },
      schoen2: {
        element: 'Line2',
        align: false,
        text: 'The Worldlist breaks the world down into 6,000 highlights.<br /><br />The Worldmodel reassembles those 6,000 highlights into a single world.<br /><br />',
        text2: 'The Worldmodel assembles the world from the rankings of the top ten highlights in each category.',
        subtitle: 'The Most Beautiful Planet in the Cosmos',
        img: {
          src: '/Img/Modell/2_Earth rise with moon.png',
          alt: '',
          width: '400px',
          caption: 'Generated based on Apollo 8',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen3: {
        element: 'Line2',
        align: true,
        text: 'The Worldlist presents the quintessence of the world—the unique, without repetition: World Highlights. Yet it remains a selection of highlights. Because they are tied to specific locations, strictly speaking they do not capture the world as a whole.<br /><br />',
        text2: 'The Worldmodel also encompasses all forms within each category. Unlike location-bound highlights, forms, styles, types and phenomena relate to the world as a whole.',
        subtitle: 'The Most Beautiful Planet in the Cosmos',
        img: {
          src: '/Img/Modell/3_Earthrise close with moon.png',
          alt: '',
          width: '400px',
          caption: 'Generated based on real satellite imagery',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen4: {
        element: 'Line2',
        align: false,
        text: 'The Worldlist answers the question: “What is significant?” The World Highlight.<br /><br />The Worldmodel answers the question: “What does it belong to?” The World Category.<br /><br />',
        text2: 'The Worldmodel answers the question: “What does it belong to?” The World Category.',
        subtitle: 'The Three Most Famous Photographs of Earth',
        img: {
          src: '/Img/Modell/4_Blue Marble the Americas.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen5: {
        element: 'Line2',
        align: true,
        text: 'The Worldmodel captures the unity of the world.<br /><br />The Worldlist captures the diversity of the world.',
        text2: 'The concept of the Worldmodel encompasses the entire world without limitation. Its presentation, however, must take the available space into account.',
        subtitle: 'The Three Most Famous Photographs of Earth',
        img: {
          src: '/Img/Modell/5_Blue Marble AfricaEurope.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen6: {
        element: 'Line2',
        align: false,
        text: 'The whole is greater than its parts.',
        text2: 'Everyone who saw it was close to tears.',
        subtitle: 'The Three Most Famous Photographs of Earth',
        img: {
          src: '/Img/Modell/6_Blue Marble AustraliaAsia.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen7: {
        element: 'Line2',
        align: true,
        text: 'Humanity is unique in the cosmos.<br /><br /> There is no evidence to the contrary.',
        text2: 'Our responsibility follows from this.<br /><br /> The responsibility of every individual.',
        subtitle: 'Earth at Night',
        img: {
          src: '/Img/Modell/7_earth at night africa europe.png',
          alt: '',
          width: '400px',
          caption: 'Generated based on real satellite imagery', 
          captionStyle: 'imageCaptionSmall',
        }
      },  
      listen: {
        element: 'BoxImage',
        align: false,
        EnumerateTag: 'li',
        // h2: 'Zum Weltmodell',
        textbutton: [
          {
            text: 'To the Worldmodel with its extremes',
            buttonText: 'LINK',
            buttonLink: 'worldmodel_extremes'
          },
          {
            text: 'To the Worldmodel with its rankings',
            buttonText: 'LINK',
            buttonLink: 'worldmodel_rankings'
          },
        ]
      },      
    },
    // =====================
    error404: {
      h1: '404 - Page not found.',
      text: 'The page you are looking for does not exist or has been moved.',
      link: 'Back to homepage',
    },
    texts: {
      list: {
        pages: 'Display {{count}} per page',
        selection: 'Current selection contains {{count}} highlights',
        selection_category: 'Current selection contains {{count}} categories',
        page: 'Page',
        page_of: ' of {{count}}',
        page_size: 'Show {{count}} per page',
        all: 'All',
        search: 'Search...',
        kontinent: 'Continent',
        land: 'Country',
        region: 'Region',
        gruppe: 'Group',
        title: 'Name of the Highlight',
        kategorie: 'Category',
        kategorien: 'Categories',
        welterbe: 'World Heritage',
        no1: 'Synoptic<br>No. 1<br>Ranking from the world list (preliminary)',
        sum_standard: 'Standard',
        sum_top: 'Top',
        sum_mega: 'Mega',
        sum_wel_unique: "World Heritage (UNESCO definition)",
        sum_wel: "World Heritage (destinations)",
        ext_all: "Synoptic Ranking of the Top Ten Highlight Locations from the Worldlist (preliminary)",
        ext_chatgpt: "Specific Ranking of the Top Ten Highlight Locations",
        ext_chatgpt2: "Specific Ranking of the Top Ten Kinds",        
        ext_chatgpt3: "Specific<br>World extreme<br>Superlative strength",
      },
      highlight: {
        kontinent: 'Continent:',
        kontregion: 'Continental region:',
        land: 'Country:',
        landregion: 'Country/Region:',
        Kategorien: 'Categories',
        Ausgangsort: 'Starting location',
        Unterorte: 'Sub-Locations',
        Zusatzorte: 'Optional Locations',
        Hotel: 'Hotel',
        Reisezeit: 'Travel time',
        UN1: 'UNESCO World Heritage',
        UN2: 'Visitor Destination of a UNESCO World Heritage site',
        prev: 'Previous Highlight',
        next: 'Next Highlight',
        close: 'Close',
        UNTooltip: 'List opens in a new window/tab',
        UNAll: 'Show all highlights of this World Heritage site',
        map_external: 'Show large map and pictures',
        nomap: 'To view this highlight directly on a Google map, you need to consent to the use of cookies. Please click here. Alternatively, you can open the location in a new tab.',
        nomap_cookie: 'Accept cookies',
        nomap_external: 'External Link',
      },
      impressum: {
        telefon: 'Phone',
        email: 'Email',
        footer: 'This website is not intended for commercial purposes. It is freely accessible to everyone and entirely non-commercial.<br />It complements the <i>Travel Joy</i> book series (<i>Reiselust</i>) by adding two dimensions that are impossible in printed form: <b>Data volume</b> (the site presents a significantly larger amount of information) and <b>Interactivity</b> (users can search, filter, and compare highlights in dynamic ways).',
        title1: 'Legal notice',
        title2: 'Contact',
      },
      kommentare: {
        title: 'Comments',
        text: 'I would be delighted if I could win you over to contribute to the Frank Grosse World Highlights List®. The list is free of charge for you. On the website, I have explained that the numerical rankings of the highlights still need to be completed. With over 6,000 highlights, this is a tremendous task. But beyond that, any help to improve is very welcome.<br /><br />Please share your feedback using the following form:',
      },
      cookie: {
        yes: 'Agreed',
        no: 'Only necessary',
        text: 'This website uses technically necessary cookies as well as others to analyze user behavior.',
      },
      sumlist: {
        title: 'The world list as a summary list: Number of world highlights',
        text1: 'Highlights into three groups, including World Heritage sites in their original form and as visitor destinations',
        sumlabel: 'Total',
      },
      categorylist: {
        title: 'Categories list, systematic (Taxonomy of the World)',
        text1: 'Explanation: Superordinate terms are marked twice: (1) highlighted in yellow (2) with "general" at the end of the name; Superordinate terms are not categories. They serve for deductive derivation. The list was compiled both deductively (from the abstract to the specific) and inductively. It captures the diversity of the world from the perspective of the traveler; in other words, in a category there are at least 3 world highlights, up to 20. A traveler should have seen at least 1 world highlight in all categories, on average 4 to 5. Then he or she has seen the whole world.',
      },
      categorylist_extended: {
        title: 'The Worldmodel with its ranking',
        text1: [
          '<b>Explanation</b>: Higher-level terms are highlighted  (1) highlighted in yellow (2) with ‘general’ at the end of their names. Higher-level terms are not categories; they serve to derive and structure the list deductively. The list is created both deductively (from the abstract to the specific) and inductively (from what actually exists to the abstract—the empirical process)',
          'For reasons of feasibility, we aim for between 3 and 20 highlights in each category. The exact number also depends on the definition, which is not yet final but already close to the ideal. For greater clarity, we have limited all columns to 10 highlights.',
          '<b>Synoptic</b>: The synoptic ranking takes the entire category system into account. If a category includes subcategories, this is reflected here.',
          '<b>Specific</b>: The specific ranking, the only one generated using AI, is based solely on the category term. It therefore does not take any subcategories into account.',
          '<b>Example</b>: The category “Building Architecture” is explained in the category list (see Worldlist), where it is marked “secular.” This means that, in the synoptic view, sacred buildings, which form a subcategory, are excluded to avoid duplicate entries. Thus, only secular buildings are shown under “Building Architecture." In the specific view, by contrast, all types of building architecture—both secular and sacred—are shown. This results in duplicate entries',
          '<b>Kinds</b>: Species, types, forms, styles, phenomena, manifestations.'
        ]
      },
      categorylist_extended2: {
        title: 'The Worldmodel with its extremes',
        // text1 identical to categorylist_extended
        text2: [
          '<b>Superlative Strength</b>: Global Rank, Magnitude of the Extreme Value, Stability, Uniqueness.',
        ],
      },
      namelist: {
        title: 'Name list',
        text1: 'In this list, all highlights are differentiated according to their significance:',
        list1: [
          '2,000 Mega Highlights - Global Multiple Extremes - <span style="background-color: orange">highlighted in orange</span>',
          '2,000 Top Highlights - Global Single Extremes - <span style="background-color: yellow">highlighted in yellow</span>',
          '2,000 Standard Highlights - regional extremes with global significance - <span>not highlighted</span>',
        ],
        text2: 'At a glance:',
        list2: [
          'What are the highlights of the country?',
          'What are the highlights of the region?',
          'Which highlights are World Heritage Sites?',
        ],
        text3: 'Symbols for the relationship with World Heritage:',
        text4: [
          '28% of the highlights have a relationship to the UNESCO World Heritage. Of these, 60% are identical to the UNESCO World Heritage (highlighted in green: <span style="background-color: lightgreen">UN</span>), but 40% have a modified relationship (not highlighted: UN) because the UNESCO World Heritage does not define any or meaningful visiting destinations: Therefore, we modify the UNESCO World Heritage:',
          '(1) It is either expanded to include visitation goals: 17% (typical for large protected areas)',
          '(2) or it focuses on visitor destinations: 23% (typical for too many "multi locations")',
          'World Heritage sites, country-specific: 1,324 (as of 2025). Frank Grosse: 1,812 World Heritage visitor destinations',
        ],
      }
    },
    joyride: {
      nav: {
        back: 'Back',
        close: 'Close',
        last: 'Close',
        next: 'Continue',
        skip: 'Finish Tour',
      },
      steps: [
        {
          target: '#root',
          content: 'Welcome to the Frank Grosse World Highlights List. The following tour explains how to navigate within the list of 6000 highlights.',
          disableBeacon: true,
          placement: 'center',
        },
        {
          target: '.table-header-Kontinent',
          content: 'Each line contains a highlight. The highlights are grouped by continent.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Land',
          content: 'The country list is an expanded list of UN member states, it includes more than these 193.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-LandRegion',
          content: 'Regions within a country,',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Gruppe',
          content: 'Highlight types: Standard, Top, and Mega, each containing 2000 highlights.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Beschreibung',
          content: 'The highlights are sorted in a geographical order. It always starts with the highlights in the capital city, followed by logical geographical regions: North, West, South, East. "Central" may also be included. In elongated countries, it may only be North and South or East and West. The region is indicated in the highlight text.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kategorien',
          content: 'and after over 1500 categories.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kontinent span',
          content: 'By clicking on the title (e.g. here Continent), the sorting of the list is changed (an arrowhead appears: pointing upwards means the countries are sorted alphabetically in ascending order, pointing downwards means they are sorted alphabetically in descending order). A second click will reverse the sorting.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kontinent select',
          content: 'The dropdown allows restricting the selection.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Beschreibung input',
          content: 'You can search for terms.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_buttons',
          content: 'With the arrows you can navigate to the next pages: Single arrow for previous or next page, double arrow for first or last page.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_pages',
          content: 'The current page out of the total number of pages in the current selection.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#pagination_perpage',
          content: 'To keep the table organized, choose as many rows as you actually need.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_currentselection',
          content: 'The highlights in the current selection. Example: If you have selected "all" for continent, group, and categories, and only one country, it will show you the total number of highlights for that country.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_tour',
          content: 'If you want to repeat this tour later, click here.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#worldlist_table tr:nth-child(2) td:nth-child(5)',
          content: 'A click on the highlight name brings up further details.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#root',
          content: 'Have fun!',
          disableBeacon: true,
          placement: 'center',
        },
      ],
    },
  },
};

export default i18n_en;